// extracted by mini-css-extract-plugin
var _1 = "input";
var _2 = "input-group";
var _3 = "input__suffix";
export { _1 as "input", _2 as "input-group", _3 as "input__suffix" }
